import { mapSixActivitiesDTOToSixActivities, mapSixFilesDTOToSixFiles, mapSixFoldersDTOToSixFolders, mapSixSummaryToParticipants } from "@/store/mappers/mapSixDetail";
import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";
import { syncFilesFromApi } from "@/store/thunks/sixDetail/syncFilesThunk";

export const initSixDetail = createAppAsyncThunk(
  "sixDetail/initSixDetail",
  async(sixId: string, { dispatch, extra }) => {
      const meta = await extra.sixDetailService.getMeta(sixId);
      const filesResponse = await extra.sixDetailService.fetchFiles(sixId);
      const activityDTO = await extra.sixDetailService.fetchActivity(sixId);

      const {participants} =  mapSixSummaryToParticipants(meta);
      const activity = mapSixActivitiesDTOToSixActivities(activityDTO);
      const files = mapSixFilesDTOToSixFiles(filesResponse.files);
      const folders = mapSixFoldersDTOToSixFolders(filesResponse.folders);

      // Trigger file sync to check local Helia storage and download missing files.
      // Pass files directly — dispatching before the return means the fulfilled
      // reducer hasn't stored them in Redux yet, so reading from state would be stale.
      void dispatch(syncFilesFromApi({ sixId, files }));

      return {
        sixId,
        meta,
        files,
        folders,
        activity,
        participants
      };
  }
);
